export default () => {
  const enquiryReasonDropdown = document.getElementById('lesson_course_enquiry_reason_for_enquiry')
  const freezeReason = document.querySelector('.lesson_course_enquiry_reason_for_freeze')
  const freezeReasonDropdown = document.getElementById('lesson_course_enquiry_reason_for_freeze')
  const uploadSection = document.getElementById('lesson-freeze-upload')
  const uploadActions = document.getElementById('lesson-enquiry-upload-actions')
  const submitActions = document.getElementById('lesson-enquiry-submit-actions')

  const setDisplay = (element, show) => {
    if (element) element.style.display = show ? 'block' : 'none'
  }

  const setDisabled = (container, disabled) => {
    if (!container) return
    container.querySelectorAll('input, button').forEach(node => { node.disabled = disabled })
  }

  const doneUploading = !!document.querySelector('input[name="lesson_course_enquiry[done_uploading_proof]"]')

  const needsUpload = () =>
    enquiryReasonDropdown && enquiryReasonDropdown.value === 'Lesson Freeze' &&
    freezeReasonDropdown &&
    (freezeReasonDropdown.value === 'Medical or injury related' ||
      freezeReasonDropdown.value === 'Pregnancy')

  const refresh = () => {
    const isFreeze = enquiryReasonDropdown && enquiryReasonDropdown.value === 'Lesson Freeze'
    setDisplay(freezeReason, isFreeze)

    // Once the customer has clicked "Done Uploading Proof" the server renders the
    // final submit step; leave that in place rather than forcing back to upload mode.
    if (doneUploading) return

    const uploading = needsUpload()
    setDisplay(uploadSection, uploading)
    setDisplay(uploadActions, uploading)
    setDisabled(uploadActions, !uploading)
    setDisplay(submitActions, !uploading)
    setDisabled(submitActions, uploading)
  }

  if (enquiryReasonDropdown) {
    enquiryReasonDropdown.addEventListener('change', refresh)
  }
  if (freezeReasonDropdown) {
    freezeReasonDropdown.addEventListener('change', refresh)
  }
  if (enquiryReasonDropdown) {
    refresh()
  }



  // CANCELLATIONS

  const reason = document.querySelector('#lesson_course_cancellation_reason');
  const movingLink = document.querySelector("[data-attr='location-link']");

  if(reason){
    movingLink.style.marginBottom = '20px';
    movingLink.style.display = 'none';
    movingLink.style.textAlign = 'center';

    reason.addEventListener('change', () => {
      if(reason.value == 'Moving Away'){
        movingLink.style.display = 'block';
      } else {
        movingLink.style.display = 'none';
      }
    })

  }



};
